// Single source of truth for todo-kind → human label, shared between
// the Pipeline kanban card and the NextActionBox agent-todos panel on
// piece detail.

const VERBS: Record<string, string> = {
  schedule_piece:       "assign a slot",
  decide_failed:        "decide what to do",
  decide_bump_exceeded: "decide — bump exceeded",
}

export function todoVerb(kind: string): string {
  return VERBS[kind] ?? kind.replace(/_/g, " ")
}

export function todoLabel(todo: { assignee: string; kind: string }): string {
  return `${todo.assignee === "agent" ? "Agent" : "You"}: ${todoVerb(todo.kind)}`
}
